export default {
  completedTasks: [],
  completedTask: undefined,
};
